module.exports = (__webpack_require__(1))(16);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/UserModel.js from dll-reference girder_lib
// module id = 15
// module chunks = 0